
import React from "react";

export const AccessDenied: React.FC = () => {
  return (
    <div className="pt-24 px-6 text-red-400 text-center">
      <h2 className="text-3xl font-bold mb-4">Acesso Restrito</h2>
      <p className="text-xl">Apenas administradores podem acessar esta página.</p>
    </div>
  );
};
